// The Due Diligence face, and since report 806823ce the whole app's default ("Change the default font to
// Google Sans"): --font-sans in global.css is this stack. That module was rebuilt from the original Cognito form
// and set its own type; SLF Property's own bar and the desk toolbars follow it (owner 2026-09-25: 字体全部按照
// Due Diligence 里的字体来显示), so the constant lives here and everyone reads the same one instead of each
// file carrying its own copy of the stack.
//
// Google Sans itself, not Google Sans Flex or Text. It is a web font: public/index.html loads its sheet for the app, in
// the weights in use, so a 500 stays medium and a 600 semi-bold and anything heavier renders as 700. A page the app
// writes for itself has to ask for the sheet too (RC_LINK). A machine that cannot reach the host gets the names
// behind it.
export const RC = "'Google Sans', Helvetica, Arial, sans-serif";
export const RC_LINK = '<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Google+Sans:wght@400;500;600;700&display=swap">';

// The rule that makes a whole console inherit it. Form controls have to be named: buttons, inputs,
// selects and textareas do not inherit font-family. Icons are unaffected — `.ti` matches the <i>
// itself, and a rule that matches an element always beats a value inherited from its parent.
// Older than the app-wide default, and the consoles that use it now say the same thing twice.
export const rcScope = (cls: string) =>
  `.${cls}, .${cls} button, .${cls} input, .${cls} select, .${cls} textarea { font-family: ${RC}; }`;
